import { Card } from './Card/Card';

export function Cards({
    items,
    setChatInputValue,
    sendMessage,
    quantityQuestions,
    defaultQuestions,
}: {
    items: {
        id: string;
        title: string;
        icon?: string;
        isFavorite?: boolean;
        interactionId?: string;
    }[];
    setChatInputValue: React.Dispatch<React.SetStateAction<string>>;
    sendMessage: (msg: string) => void;
    quantityQuestions?: number;
    defaultQuestions: string[];
}) {
    const totalItems = items.slice(0, quantityQuestions ?? items.length);

    return (
        <div className={`grid grid-cols-2 gap-4`} data-testid="cards">
            {totalItems.map((item, index) => (
                <Card
                    key={item.id ?? index}
                    item={item}
                    setChatInputValue={setChatInputValue}
                    sendMessage={sendMessage}
                    defaultQuestions={defaultQuestions}
                />
            ))}
        </div>
    );
}

export default Cards;
